export default [
  {
    path: '/integralMall',
    name: 'integralMall',
    component: () => import('@views/integralMall/index.vue'),
    meta: {
      title: '积分商城首页'
    }
  },
  {
    path: '/integralMallList',
    name: 'integralMallList',
    component: () => import('@views/integralMall/integralMall.vue'),
    meta: {
      title: '积分商城列表'
    }
  },
  {
    path: '/proDuctDetail',
    name: 'proDuctDetail',
    component: () => import('@views/integralMall/proDuctDetail.vue'),
    meta: {
      title: '产品详情'
    }
  },
  {
    path: '/myOrder',
    name: 'myOrder',
    component: () => import('@views/integralMall/myOrder.vue'),
    meta: {
      title: '我的订单'
    }
  }
]
